<div class="modal-content">
    <div class="modal-header bg-black">
        <div class="modal-title">
            <h6 class="text-white">Custom Details</h6>
        </div>

        <button type="button" class="btn-close" aria-label="close" (click)="close()">
            <img src="assets/img/icon_cancel.png" alt="close icon">
        </button>
    </div>
    <div>
        <div class="modal-body my-3 px-3">
        


            <div class="col-md-12">
                <table class="table table-bordered table-sm assess-table">
                  <thead class="table-dark">
                    <tr>
                      <th class="assess-table-head">#</th>
                      <th class="assess-table-head">Name</th>
                      <th class="assess-table-head">Type</th>
                      <th class="assess-table-head">Amount</th>
                      <th class="assess-table-head">Reg. Amount</th>
                      <th class="assess-table-head">Renewal Amount</th>
                      <th class="assess-table-head">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let file of customPrices; let i = index">
                      <td>{{ i + 1 }}</td>
                      <td>{{ file?.serviceName | titlecase}}</td>
                      <td>{{ file?.serviceType | removeUnderscores | titlecase}}</td>
                      <td *ngIf="file?.amount">{{ file?.amount | nairaCurrency  }}</td>
                      <td *ngIf="!file?.amount">{{'n/a'}}</td>
                      <td *ngIf="file?.regAmount">{{ file?.regAmount || 'n/a' | nairaCurrency }}</td>
                      <td *ngIf="!file?.regAmount">{{'n/a'}}</td>
                      <td *ngIf="file?.renewalAmount">{{ file?.renewalAmount || 'n/a' | nairaCurrency }}</td>
                      <td *ngIf="!file?.renewalAmount">{{ 'n/a' }}</td>
                      <td  class="text-muted small">{{ file?.serviceDescription }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
      
    </div>
</div>

